<div class="background">
  <div class="box">
    <div fxLayout="column">
      <div fxLayout="row">
        <div fxFlex></div>
        <app-progressbar [maxStep]="1" [step]="1"></app-progressbar>
      </div>
      <div class="content">
        <span class="title">{{ 'LOAD_CONFIGURATION.TITLE' | translate }}</span>
        <p>{{ 'LOAD_CONFIGURATION.DESCRIPTION' | translate }}</p>
        <div class="input">
          <app-isomasters-input
            (valueChange)="updateConfiguration($event)"
            [autocomplete]="false"
            [placeholder]="'LOAD_CONFIGURATION.PLACEHOLDER' | translate"
            [value]="configurationId"></app-isomasters-input>
        </div>
        <div class="button">
          <app-isomasters-button (modularClick)="load()" [disabled]="!configurationId" [loading]="loading">
            <div description>{{ 'LOAD_CONFIGURATION.LOAD' | translate }}</div>
          </app-isomasters-button>
        </div>
        <div *ngIf="!exists" class="error">
          {{ 'LOAD_CONFIGURATION.DOES_NOT_EXIST' | translate }}
        </div>
        <div *ngIf="invalidGuid" class="error">
          {{ 'LOAD_CONFIGURATION.INVALID_GUID' | translate }}
        </div>
      </div>
    </div>
  </div>
</div>
